import { normalize, schema } from 'normalizr';

export default {
  UPDATE_USER(state, payload) {
    if (!payload) {
      state.usuario = {};
      state.empresas = {};
      state.empresasSelecionadas = [];
      return;
    }
    const empresa = new schema.Entity('empresa');
    const usuarioEmpresas = new schema.Entity('empresas', { empresa });
    const usuario = new schema.Entity('usuario', { empresas: [usuarioEmpresas] });
    const {
      entities,
      result,
    } = normalize(payload, usuario);

    state.usuario = entities.usuario[result];
    state.empresas = entities.empresas;
    state.empresasSelecionadas = Object.keys(state.empresas);
  },
  SET_TIPOS_USUARIO(state, payload) {
    state.tiposUsuario = payload;
  },
  SET_USUARIO(state, payload) {
    state.usuario = payload;
  },
  SET_EMPRESA(state, payload) {
    state.empresa = payload;
  },
  SET_EMPRESAS(state, payload) {
    state.empresas = payload;
  },
  SET_EMPRESAS_SELECIONADAS(state, payload) {
    state.empresasSelecionadas = payload;
  },
  SET_ESPECIALISTA_OPERACIONAL(state, payload) {
    state.especialistaOperacional = payload;
  },
  SET_ESPECIALISTA_COMERCIAL(state, payload) {
    state.especialistaComercial = payload;
  },
  UPDATE_USUARIO_STATE(state, payload) {
    state.usuario = payload;
  },
  SET_EMAILS_DOMAIN(state, payload) {
    state.listaEmailsMesmoDomain = payload;
  },
  SET_TEAM_TRINITY(state, payload) {
    state.teamTrinity = payload;
  },
  SET_LAST_FETCH_NOTIFICATIONS(state, payload) {
    state.lastFetchNotifications = payload;
  },
  SET_ULTIMO_FILTRO(state, payload) {
    state.ultimoFiltro = payload;
  },
  SET_ULTIMA_PAGINA(state, payload) {
    state.ultimaPagina = payload;
  },
};
